module.exports = __webpack_public_path__ + "media/img/clients-modal/neurala-d8b5c711377161478be2958e594c1c1e.svg";